import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(3);

  const plan = searchParams.get('plan') || 'VIP';

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          // Redirect to AI Coder page
          navigate('/the-coder-ai');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black flex items-center justify-center p-4">
      <div className="bg-[#ffffff] dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        {/* Success icon */}
        <div className="w-20 h-20 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Success message */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          🎉 Payment Successful!
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Your <span className="font-semibold">{plan}</span> subscription is now active!
        </p>

        {/* Info */}
        <div className="bg-teal-50 border border-teal-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-teal-800">
            You now have access to all premium features!
          </p>
        </div>

        {/* Redirect message */}
        <p className="text-sm text-gray-500 mb-4">
          Redirecting to AI Coder in {countdown} seconds...
        </p>

        {/* Manual button */}
        <button
          onClick={() => navigate('/the-coder-ai')}
          className="w-full bg-teal-600 text-white py-3 rounded-lg hover:bg-teal-700 transition"
        >
          Go to AI Coder Now →
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
